"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _Sitemap = _interopRequireDefault(require("./Sitemap"));

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSitemapsActionTypes.SUCCESS, function (state, action) {
  return (0, _mergeWithCollectionOfType.default)(_Sitemap.default, action.payload.data.objects, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveSitemapChangesActionTypes.SUCCESS, function (state, action) {
  var sitemap = action.payload.data;
  return state.set(sitemap.id, new _Sitemap.default(sitemap));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;